/* global axios */
import ApiClient from './ApiClient';

class BulkCampaignsAPI extends ApiClient {
  constructor() {
    super('bulk_campaigns', { accountScoped: true });
  }

  getAll({ status, inboxId, limit, periodType, date, page } = {}) {
    const params = {};
    if (status) params.status = status;
    if (inboxId) params.inbox_id = inboxId;
    if (limit) params.limit = limit;
    if (periodType) params.period_type = periodType;
    if (date) params.date = date;
    if (page) params.page = page;
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  checkWhatsApp(numbers) {
    return axios.post(`${this.url}/check_whatsapp`, { numbers });
  }

  parseCsv({ text, roles } = {}) {
    return axios.post(`${this.url}/parse_csv`, { text, roles });
  }

  testSend({ inboxId, content, contact }) {
    return axios.post(`${this.url}/test_send`, {
      inbox_id: inboxId,
      content,
      contact,
    });
  }
}

export default new BulkCampaignsAPI();
